<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Power Systems</title>
<link href="9780805096163.css" rel="stylesheet" type="text/css"/>
<meta content="application/xhtml+xml; charset=utf-8" http-equiv="default-style"/>
<div id="cov"><img alt="image" src="OEBPS/images/cover.jpg" style="height:100%;"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780805096163_cov.vue?45b4c308